module.exports = __webpack_public_path__ + "static/img/suidao.ab2db3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cases/suidao.png
// module id = IpS3
// module chunks = 1